<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub" v-if="type == 'monthly'"><i class="el-icon-date"></i> Monthly Contracy
          history</span>
        <span style="vertical-align: sub" v-else><i class="el-icon-date"></i> Compliance Contracy history</span>
      </div>
      <div v-if="historyData && historyData.history.length > 0">

        <el-descriptions :column="1" v-if="historyData.contract_details">

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-data-line"></i>
              Status
            </template>
            {{ historyData.contract_details.status.toUpperCase() }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-money"></i>
              Total
            </template>
            {{ historyData.contract_details.total_amount }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-date"></i>
              Month Agreement
            </template>
            {{ historyData.contract_details.duration_months }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-coin"></i>
              Currency
            </template>
            {{ historyData.contract_details.currency.toUpperCase() }}
          </el-descriptions-item>

        </el-descriptions>
        <div style="margin-top:20px"></div>
        <el-table :data="historyData.history" border style="width: 100%" v-loading="loading" height="400">
          <el-table-column prop="transactionDate" label="Date" width="180" align="center">
            <template slot-scope="scope">{{ dateFormat(scope.row.transactionDate) }}</template>
          </el-table-column>
          <el-table-column prop="monthIndex" label="Month" width="80" align="center"></el-table-column>
          <el-table-column prop="description" label="Description"></el-table-column>
          <el-table-column prop="debit" label="Debit" width="120" align="right">
            <template slot-scope="scope">{{ numberFormat(scope.row.debit) }}</template>
          </el-table-column>
          <el-table-column prop="credit" label="Credit" width="120" align="right">
            <template slot-scope="scope">{{ numberFormat(scope.row.credit) }}</template>
          </el-table-column>
          <el-table-column prop="balance" label="Balance" width="120" align="right">
            <template slot-scope="scope">{{ numberFormat(scope.row.balance) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else v-loading="loading" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
        <span v-if="!loading" style="color: #909399;">No Data</span>
      </div>
    </el-card>
  </div>

</template>

<script>
import { getContractStateHistory } from "@/api/customer";
import { currencyFormat, dateFormat } from "@/utils";

export default {
  name: "ContractHistory",
  props: {
    customerUID: String,
    type: String
  },
  data() {
    return {
      loading: false,
      historyData: null,
    };
  },

  methods: {
    numberFormat(value) {
      return currencyFormat(Number(value), '');
    },
    dateFormat(value) {
      return dateFormat(value, 'DD/MM/YYYY HH:mm:ss');
    },
    getHistory() {
      this.loading = true;
      this.historyData = null;
      getContractStateHistory(this.customerUID, this.type).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.historyData = data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

  },
  mounted() {
    this.getHistory();
  }
};
</script>

<style lang="scss" scoped></style>